import { MembersViewContent } from './components/members-view-content';
import { UserManagementProvider } from './context';

export function UserManagementView() {
  return (
    <UserManagementProvider>
      <MembersViewContent />
    </UserManagementProvider>
  );
}
